/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.giftCards

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.giftCards.internal.GiftCardsUseCase
import features.giftCards.internal.GiftCardsUseCase.Params
import features.giftCards.models.GiftCardsModel


typealias GiftCardsState = CFlow<GiftCardsUseCaseResult?>

typealias GiftCardsUseCaseResult = Result<GiftCardsModel>

fun GiftCardsUseCaseResult.serializeGiftCardsApiResult(): SerializedResult<String> {
    return this.toJsonResult<GiftCardsModel>()
}

/**
 * Serializes [GiftCardsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun GiftCardsState.serializeGiftCardsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<GiftCardsModel>()
    }.asCFlow()
}

/**
 * Get a list of gift cards available for purchase [Api] class
 */
class GiftCardsApi : Api() {

    val giftCardsState: GiftCardsState
        get() = _giftCardsState.asCFlow()

    companion object {
        private val _giftCardsState: MutableStateFlow<GiftCardsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val giftCardsUseCase = GiftCardsUseCase()

    /**
     * Get a list of gift cards available for purchase
     */
    suspend fun getGiftCards(
        overrideHeaders: Map<String, String>? = null,

    ): Result<GiftCardsModel> {
        /* set state to Loading as soon as function is called */
        _giftCardsState.value = Loading()
        val result = this.giftCardsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _giftCardsState.value = result
            return@giftCardsUseCase result
        }
        return result
    }

}
